'use client';

import { useEffect } from 'react';

// Registers /sw.js on mount and reloads the page when a new SW takes over.
// Skipped in dev to avoid Next.js HMR fighting with the cache; flip the
// `if` if you specifically want to test SW behavior locally.
//
// Update-reload pattern: when a deploy ships a new sw.js, the browser fetches
// it, installs it (skipWaiting), activates it (clients.claim), and fires
// `controllerchange` on existing clients. We reload on that event so the page
// picks up the new HTML + JS without the user having to hard-refresh. The
// `hadController` guard skips the first-ever registration (when controller
// flips from null → SW for the first time) so we don't reload on fresh visits.
export function ServiceWorkerRegistrar() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;
    if (process.env.NODE_ENV !== 'production') return;

    const hadController = navigator.serviceWorker.controller !== null;
    let refreshing = false;

    const onControllerChange = () => {
      if (!hadController) return;
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    };

    navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('Service worker registration failed:', err);
    });

    return () => {
      navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
    };
  }, []);

  return null;
}
